import './Header.css';
import { Navbar, Nav, NavDropdown, Container } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { useState } from 'react';

const Header = () => {
  const location = useLocation(); // Get the current path
  const [expanded, setExpanded] = useState(false);

  // Function to handle navigation link clicks
  const handleNavClick = () => {
    setExpanded(false);
  };

  return (
    <Navbar
      bg="light"
      expand="lg"
      sticky="top"
      className="shadow-sm"
      expanded={expanded}
      onToggle={(expanded) => setExpanded(expanded)}
    >
      {/* Full-width container for the Navbar */}
      <Container>
        <Navbar.Brand
          as={Link}
          to="/"
          className="ms-3"
          onClick={handleNavClick}
        >
          <img
            src="/assets/logo/awm_logo5.png"
            alt="AWM"
            width="100"
            height="44"
            className="img-fluid"
          />
        </Navbar.Brand>
        {/* Toggle button for mobile view */}
        <Navbar.Toggle aria-controls="navbarNav" />
        {/* Collapsible navigation */}
        <Navbar.Collapse id="navbarNav">
          {/* Standard container to center Nav items */}
          <Container>
            <Nav className="me-auto ms-4">
              {/* Primary Navigation Items */}
              <Nav.Link
                as={Link}
                to="/"
                className="custom-color ms-4"
                active={location.pathname === '/'}
                onClick={handleNavClick}
              >
                HOME
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/about-us"
                className="custom-color ms-4"
                active={location.pathname === '/about-us'}
                onClick={handleNavClick}
              >
                ABOUT US
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/board-members"
                className="custom-color ms-4"
                active={location.pathname === '/board-members'}
                onClick={handleNavClick}
              >
                EXECUTIVE COMMITTEE
              </Nav.Link>

              {/* Community Dropdown */}
              <NavDropdown
                title="COMMUNITY"
                id="community-dropdown"
                className="custom-color ms-4"
                active={[
                  '/community',
                  '/maintenance',
                  '/projects',
                  '/gallery',
                  '/nearby-locality',
                ].some((path) => location.pathname === path)}
              >
                <NavDropdown.Item
                  as={Link}
                  to="/community"
                  active={location.pathname === '/community'}
                  onClick={handleNavClick}
                >
                  OVERVIEW
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item
                  as={Link}
                  to="/maintenance"
                  active={location.pathname === '/maintenance'}
                  onClick={handleNavClick}
                >
                  MAINTENANCE
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item
                  as={Link}
                  to="/projects"
                  active={location.pathname === '/projects'}
                  onClick={handleNavClick}
                >
                  PROJECTS
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item
                  as={Link}
                  to="/gallery"
                  active={location.pathname === '/gallery'}
                  onClick={handleNavClick}
                >
                  GALLERY
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item
                  as={Link}
                  to="/nearby-locality"
                  active={location.pathname === '/nearby-locality'}
                  onClick={handleNavClick}
                >
                  NEARBY LOCALITY
                </NavDropdown.Item>
              </NavDropdown>

              <Nav.Link
                as={Link}
                to="/faq"
                className="custom-color ms-4"
                active={location.pathname === '/faq'}
                onClick={handleNavClick}
              >
                FAQ
              </Nav.Link>

              <Nav.Link
                as={Link}
                to="/support"
                className="custom-color ms-4"
                active={location.pathname === '/support'}
                onClick={handleNavClick}
              >
                SUPPORT
              </Nav.Link>
            </Nav>
          </Container>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;
